import { APP_URL, ENTITIES_LOGO_URL, ENTITIES_URL, LOGOS_URL, S3_URL } from "src/config";

export const entitiesUrl = (id: string) => `${S3_URL}/${ENTITIES_URL}/${id}.png`;
export const entitiesLogoUrl = (id: string) => `${S3_URL}/${ENTITIES_LOGO_URL}/${id}.png`;
export const serviceUrl = (
	type: string,
	id: string,
	themeType: string,
	locale: string,
	positionType?: string
) =>
	`${APP_URL}/link/${type}?id=${id}&themeType=${themeType}&locale=${locale}${
		positionType ? `&subproduct=${positionType}` : ""
	}`;
export const brandUrl = (brandName: string) => {
	const url = `${S3_URL}/${LOGOS_URL}/`;
	return url + brandName + ".png";
};
export const getlogoUrl = (logo: string) => `${S3_URL}/${LOGOS_URL}/${logo}`;

export const vumiIconLightURL = `${S3_URL}/${LOGOS_URL}/vumi_icon_light.png`;
export const vumiIconDarkURL = `${S3_URL}/${LOGOS_URL}/vumi_icon_dark.png`;
